<ng-container *ngIf="data.version!=2; else version2">


    <div *ngIf="(user.status==0 || !isSameArtist)">
        <a class='btn btn-sm' *ngIf="user.status==0; else loggedinUser"
            (click)="dialog.openLoginDialog(1,'action','follow')" title='Follow'>Follow</a>
        <ng-template #loggedinUser>
            <a class='btn-sm btn-follow' *ngIf="isFollowing" (click)="followArtist('unfollow')"
                [class.disabled]="followLoading" title='Unfollow'>Following</a>
            <a class=' btn-sm' *ngIf="!isFollowing" (click)="followArtist('follow')" [class.disabled]="followLoading"
                title='Follow'>Follow</a>
        </ng-template>
    </div>
</ng-container>
<ng-template #version2>

    <ng-container *ngIf="data.multiFollow; else single">
        <span *ngIf="(user.status==0 || !isSameArtist)">
            <a *ngIf="user.status==0; else loggedinUser" (click)="dialog.openLoginDialog(1,'action','follow')"
                title='Follow'>Follow All</a>
            <ng-template #loggedinUser>
                <a *ngIf="isFollowing" (click)="followArtist('unfollow','multiple')" [class.disabled]="followLoading"
                    title='Unfollow'>Unfollow All</a>
                <a *ngIf="!isFollowing" (click)="followArtist('follow' ,'multiple')" [class.disabled]="followLoading"
                    title='Follow'>Follow All</a>
            </ng-template>
        </span>
    </ng-container>

    <ng-template #single>
        <span *ngIf="(user.status==0 || !isSameArtist)">
            <a *ngIf="user.status==0; else loggedinUser" (click)="dialog.openLoginDialog(1,'action','follow')"
                title='Follow'>Follow {{data?.isFromTile ? "Artist" : ""}} </a>
            <ng-template #loggedinUser>

                <ng-container *ngIf="typeMultifollow; else singleU">
                    <a *ngIf="global.isMultipleFollow && isFollowing" (click)="followArtistV2('unfollow','multiple')"
                        [class.disabled]="followLoading" title='Follow'>Unfollow {{data?.isFromTile ? "Artist" :
                        ""}}</a>

                    <a *ngIf="!global.isMultipleFollow && !isFollowing" (click)="followArtistV2('follow','multiple')"
                        [class.disabled]="followLoading" title='Follow'>Follow {{data?.isFromTile ? "Artist" : ""}}</a>
                </ng-container>
                <ng-template #singleU>
                    <a *ngIf="isFollowing" (click)="followArtist('unfollow')" [class.disabled]="followLoading"
                        title='Unfollow'>Unfollow {{data?.isFromTile ? "Artist" : ""}} </a>
                    <a *ngIf="!isFollowing" (click)="followArtist('follow')" [class.disabled]="followLoading"
                        title='Follow'>Follow {{data?.isFromTile ? "Artist" : ""}}</a>
                </ng-template>



            </ng-template>
        </span>
    </ng-template>


</ng-template>
